import { render, staticRenderFns } from "./Invest.vue?vue&type=template&id=7406fcfc&scoped=true"
import script from "./Invest.vue?vue&type=script&lang=js"
export * from "./Invest.vue?vue&type=script&lang=js"
import style0 from "./Invest.vue?vue&type=style&index=0&id=7406fcfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406fcfc",
  null
  
)

export default component.exports